<template>
  <v-snackbar :value="value"
              data-qa="vc-toast"
              :color="getColor"
              :timeout="timeout"
              bottom
              left
              v-on="$listeners">
    {{$t(text)}}
  </v-snackbar>
</template>

<script>
  export default {
    name: "Toast",
    props: {
      value: {
        type: Boolean,
        required: true
      },
      color: {
        type: String,
      },
      error: {
        type: Boolean,
        default: false
      },
      timeout: {
        type: Number,
        default: 3000,
      },
      text: {
        type: String,
        default: 'common.actions.success'
      },
    },
    computed: {
      getColor() {
        if(this.color) return this.color;
        if(this.error) return '#c45b4b';
        return 'rgba(22,160,133,0.87)';
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>
